
import apiHandling from './apiHandling'
const VALID_UUID_PATTERN = "/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i";

class apiVRTraining extends apiHandling {
    constructor() {
        super();
    }
        
    static initTraining = (employeeUuid = null,appointment=null,flow=null,scenario=null) => {
        let jsonData = JSON.stringify({
            employee_uuid :employeeUuid,
            appointment   :appointment,
            flow          :flow,
            scenario      :scenario
            })            
        return this.req({
            method: 'post',
            action: 'vr/init',   
            data:jsonData                    
        });
    }

    static getStatus = (trainigiId) => {
         return this.req({
            method: 'get',
            action: 'vr/status',    
            data: {
                training:trainigiId
            }                    
        });
    }

    static finishTraining = (trainingId) =>{
        let jsonData = JSON.stringify({
            training: trainingId
            })            
        return this.req({
            method: 'post',
            action: 'vr/finish',   
            data:jsonData                    
        });
    }
}

export default apiVRTraining;
